import { TTermsAndConditionsEntry } from '../models/termsAndConditions.ts';
import { findDocs } from '../payload/client.ts';
import { TPayloadTerms } from '../payload/types.ts';
import { fetchStaticConfig } from '../staticConfig.ts';

const COLLECTION = 'terms_and_conditions';

const TERMS_LIMIT = 100;

const TERMS_FIELDS = ['name', 'title', 'content', 'content_html'];

const byName = (
  docs: TPayloadTerms[],
): Record<string, TTermsAndConditionsEntry> =>
  docs.reduce<Record<string, TTermsAndConditionsEntry>>((acc, doc) => {
    if (doc?.name) {
      acc[doc.name] = {
        title:   doc.title ?? '',
        content: doc.content_html ?? '',
      };
    }

    return acc;
  }, {});

const isPayloadShaped = (entries: TPayloadTerms[]) =>
  entries.every((entry) => entry && 'content_html' in entry);

export const getTermsAndConditions = async ({
  flowName,
  language,
  names,
}: {
  flowName: string;
  language: string;
  names: string[];
}): Promise<Record<string, TTermsAndConditionsEntry>> => {
  const referenced = [...new Set(names.filter(Boolean))].sort();

  if (!referenced.length) {
    return {};
  }

  try {
    const docs = await findDocs<TPayloadTerms>(COLLECTION, {
      locale: language,
      limit:  TERMS_LIMIT,
      select: TERMS_FIELDS,
      where:  { 'where[name][in]': referenced.join(',') },
    });

    return byName(docs);
  } catch (error) {
    console.error('CMS terms fetch failed, trying static JSON:', error);

    const { terms } = await fetchStaticConfig({ flowName, language });

    if (!terms?.length || !isPayloadShaped(terms)) {
      throw new Error(`The published config for ${flowName}/${language} holds no usable terms`);
    }

    return byName(terms);
  }
};
